<template>
  <div class="cycle-page">
    <router-view></router-view>
    <div class="content-map" :class="{'hide-map': path!=='/home/cycle'}">
      <chart_map></chart_map>
    </div>
    <switch_map_btn mapPathName="cycle"></switch_map_btn>
  </div>
</template>

<script>
  import ChartMap from '@/view/map'
  import SwitchMapBtn from '../components_bit/SwitchMapBtn'
  export default {
    components: {
      switch_map_btn: SwitchMapBtn,
      chart_map: ChartMap
    },
    created () {
      this.$store.dispatch('getCaseList')
      if (this.solutionStatus === 0 && this.$router.history.current.name === 'cycle') {
        this.$router.push({name: 'import'})
      }
    },
    computed: {
      solutionStatus: {
        get () {
          return this.$store.getters.solutionStatus
        }
      },
      path: {
        get () {
          return this.$store.state.route.path
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  .hide-map {
    z-index: -1;
  }
  .content-map {
    position: absolute;
    top: 6.13em;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .page-top {
    z-index: 4;
  }
  .cycle-page {
    display: flex;
    flex:1;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// cycle.vue?30c89153